import { path } from 'ramda';
import { api } from '../../services/api.js';
import { remoteAction } from '../../services/actionService.js';

export const getAgendaSessions = ({disableCache = false} = {}) => (dispatch, getStore) => {
  const visitId = getStore().global.visitId;
  const cachedAt = path(['visitDetails', visitId, 'sessions', 'cachedAt'], getStore());
  const getSessions = () => api.get(`/visits/${visitId}/agendasessions`).then(({data}) => data);
  if(!disableCache && cachedAt){
    return;
  }
  return dispatch(remoteAction({
    type: 'AGENDA_SESSIONS_GET',
    action: getSessions,
    metadata: { visitId }
  }));
};
